import script from "./LiquidityManagementDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiquidityManagementDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__